<template>
  <div v-if="myNotification">
    <b-sidebar
      backdrop
      lazy
      id="sidebar-pddf"
      title="Dynamic Fields"
      bg-variant="white"
      v-model="showSideBar"
    >
      <div class="px-3 py-2">
        Copy dynamic field, and then paste it into your template.
        <hr />

        <div v-for="key in keyItems" v-bind:key="key.key" class="pb-3">
          <div class="d-flex">
            <a href="#" @click.prevent="copy(key.key)">
              <div
                v-b-tooltip.hover.right
                :title="key.value"
                v-html="'{{' + key.key + '}}'"
              ></div>
            </a>
          </div>
        </div>
      </div>
    </b-sidebar>

    <b-modal ref="previewModal" hide-footer>
      <Preview :notification="myNotification" :keyItems="keyItems" />
    </b-modal>

    <b-modal ref="changeDefaultModal" hide-footer size="xl">
      <ChangeDefault
        @onDefaultTemplateUpdated="
          (e) => {
            $refs.changeDefaultModal.hide();
            $emit('onDefaultTemplateUpdated', {
              ...notification,
              ...e,
              isDefault: true,
            });
          }
        "
        :notification="notification"
        :keyItems="keyItems"
        :defaultTemplate="defaultTemplate"
        :defaultTemplatesReminders="defaultTemplatesReminders"
      />
    </b-modal>

    <validation-observer v-slot="{ handleSubmit }">
      <form method="post" @submit.prevent="handleSubmit(upsertNotification)">
        <div v-if="notification">
          <div class="">
            <b-row class="m-0">
              <b-col class="p-4 rounded border">
                <b-row class="pb-3 ">
                  <b-col>
                    <template v-if="!myNotification.onGoingDay">
                      <h3 v-if="myNotification.id < 0">
                        New Notification
                      </h3>

                      <template v-if="myNotification.id > 0">
                        <h3 v-if="!myNotification.day == 0">
                          Day {{ myNotification.day }} Email Notification
                        </h3>

                        <h3 v-if="myNotification.day == 0">
                          Day 0 Email Notification
                        </h3>

                        <p v-if="myNotification.day == 0">
                          This notification is sent immediately upon a payment
                          plan becoming past due.
                        </p>
                      </template>
                    </template>
                    <template v-if="myNotification.onGoingDay">
                      <h3>
                        Ongoing Email Notifications
                      </h3>

                      <p>
                        This notification will be sent when payment plans have
                        completed all their cycles, but still have a past due.
                      </p>
                    </template>
                  </b-col>
                </b-row>

                <template v-if="myNotification.onGoingDay">
                  <label class="label">Send Every</label>
                  <b-form-select
                    v-model="myNotification.onGoingDay"
                    class="mb-3"
                  >
                    <template v-for="i in getDayCount">
                      <option :key="i" :value="i" v-if="i == 1"
                        >{{ i }} Day</option
                      >

                      <option :key="i" :value="i" v-if="i > 1"
                        >{{ i }} Days</option
                      >
                    </template>
                  </b-form-select>
                </template>

                <template v-if="!myNotification.onGoingDay">
                  <b-row class="m-0">
                    <b-col class="p-0">
                      <label class="label">Send On</label>

                      <b-form-select
                        v-model="myNotification.day"
                        class="mb-3"
                        :disabled="myNotification.day == 0"
                      >
                        <template v-for="i in getDayCount">
                          <option
                            :key="i"
                            :value="i"
                            disabled
                            v-if="i === 0 && myNotification.day === 0"
                            >Day 0</option
                          >
                          <option :key="i" :value="i" v-if="i > 0"
                            >Day {{ i }}</option
                          >
                        </template>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </template>

                <b-row class="m-0">
                  <b-col md="auto" class="p-0 pr-2">
                    <b-form-checkbox
                      :unchecked-value="false"
                      :value="true"
                      v-model="myNotification.isTextNotification"
                      title="Text Notification"
                      >Text Notification
                      <i
                        class="title-icon fa-solid fa-circle-info"
                        v-b-popover.hover.right="
                          'If checked, the notification will be sent to the patient\'s mobile phone as well. If a patient doesn\'t have a mobile phone on file, this will be ignored.'
                        "
                      ></i
                    ></b-form-checkbox>
                  </b-col>
                  <b-col>
                    <b-form-checkbox
                      v-model="myNotification.isRetryPayment"
                      :value="true"
                      v-if="myNotification.day !== 0"
                      :unchecked-value="false"
                      title="Retry Payment"
                      >Retry Payment
                      <i
                        class="title-icon fa-solid fa-circle-info"
                        v-b-popover.hover.right="
                          'If checked, the past due amount will be retried before sending this notification. If the payment is successful, notifications will stop.'
                        "
                      ></i
                    ></b-form-checkbox>
                  </b-col>
                </b-row> </b-col
            ></b-row>
            <b-row class="m-0 mt-4 rounded border" v-if="state != 'edit'">
              <b-col class="p-0">
                <b-row
                  class="m-0 border-bottom p-4 header-gray"
                  align-v="center"
                >
                  <b-col class="p-0">
                    <h4 class="pb-0 mb-0">Notification</h4>
                  </b-col>
                  <b-col class="p-0" md="auto">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click.prevent="
                        () => {
                          state = 'edit';
                        }
                      "
                      ><i class="fa-solid fa-pen pr-2"></i>Edit
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="m-0">
                  <b-col class="p-4">
                    <Preview
                      :notification="myNotification"
                      :keyItems="keyItems"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="m-0 mt-4 rounded border" v-if="state == 'edit'">
              <b-col class="p-0">
                <b-row
                  class="m-0 border-bottom p-4 header-gray"
                  align-v="center"
                >
                  <b-col class="p-0 align-middle">
                    <h4 class="pb-0 mb-0">Notification</h4>
                  </b-col>
                  <b-col class="p-0" md="auto">
                    <b-button
                      v-if="!myNotification.isDefault"
                      variant="outline-primary"
                      size="sm"
                      @click="
                        () => {
                          state = 'preview';
                        }
                      "
                      ><i class="fa-solid fa-eye pr-2"></i>Preview
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="m-0 p-4">
                  <!--<b-col v-if="myNotification.isDefault" class="p-0">
                    <div class="light-alert light-alert-warning mb-0">
                      <i class="fa-solid fa-flag-swallowtail"></i>
                      This notification will use the
                      <a
                        href="#"
                        style="color: #fb6340; text-decoration: underline;"
                        @click="
                          () => {
                            $refs.changeDefaultModal.show();
                          }
                        "
                        >default template</a
                      >. If you'd like to customize the message for this
                      notification, please click "Custom" above.
                    </div>
                  </b-col>-->
                  <b-col v-if="!myNotification.isDefault" class="p-0">
                    <b-row v-if="hasTemplateError">
                      <b-col>
                        <div class="light-alert light-alert-error mb-2">
                          <i class="fa-solid fa-message-xmark"></i>Your
                          notification doesn't include a link to make a payment.
                          Please add
                          <span v-html="displayQueryBrackets()"></span>
                          to your message.
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="m-0">
                      <b-col class="p-0 text-right">
                        <a
                          href="#"
                          class="text-sm text-right"
                          @click.prevent="
                            () => {
                              showSideBar = true;
                            }
                          "
                        >
                          View Dynamic Fields
                        </a>
                      </b-col>
                    </b-row>
                    <b-row class="m-0 mt--2">
                      <b-col class="p-0">
                        <base-input
                          placeholder=""
                          label="Subject"
                          rules="required"
                          name="subject"
                          v-on:keyup="
                            (e) => {
                              defaultTouched = true;
                            }
                          "
                          v-model="myNotification.subject"
                        ></base-input>

                        <base-textarea
                          v-model="myNotification.message"
                          label="Message"
                          name="message"
                          :rows="8"
                          v-on:keyup="
                            (e) => {
                              defaultTouched = true;
                            }
                          "
                          rules="required"
                          placeholder="Enter the default template you want applied to all reminders that are marked as default"
                        ></base-textarea>

                        <small class="text-muted"
                          ><b>Note:</b> The practice's contact information will
                          be displayed in the footer of the email and text
                          notification.</small
                        >

                        <!--<b-checkbox>Apply to all other templates</b-checkbox>-->
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="pt-4">
              <b-col v-if="myNotification.id > 0">
                <b-button block type="submit">Save Notification</b-button>
              </b-col>

              <b-col v-if="myNotification.id < 0">
                <b-button block type="submit" variant="success"
                  >Create Notification</b-button
                >
              </b-col>

              <b-col
                md="auto"
                class="pl-0"
                v-if="
                  myNotification.id > 0 &&
                    myNotification.day > 0 &&
                    !myNotification.onGoingDay
                "
              >
                <b-button variant="outline-danger" @click="handleDeleteClick"
                  >Delete</b-button
                >
              </b-col>
            </b-row>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import Preview from "./preview";
import ChangeDefault from "./changeDefault";

export default {
  components: { Preview, ChangeDefault },
  props: {
    defaultTemplatesReminders: null,
    startDay: null,
    notification: null,
    defaultTemplate: null,
    state: "preview",
    keyItems: null,
  },
  data() {
    return {
      myNotification: null,
      initialNotification: null,
      hasTemplateError: false,
      defaultTouched: false,
      showSideBar: false,
    };
  },
  watch: {
    notification: {
      handler: function(val, oldVal) {
        if (val) {
          this.myNotification = JSON.parse(JSON.stringify(val));
          this.defaultTouched = false;
          this.initialNotification = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
    },
  },
  computed: {
    getDayCount() {
      return Array.from({ length: 28 }, (_, i) => i);
    },
  },
  methods: {
    displayQueryBrackets() {
      return "{{" + "[Process Payment]linkForPayment" + "}}";
    },
    processTemplate(m) {
      //loop through the key items and replace the keys with the values dont use regex

      if (this.keyItems) {
        this.keyItems.forEach((element) => {
          m = m.replace(element.key, element.value);
        });
      }

      return m;
    },
    copy(key) {
      let t = key;

      navigator.clipboard.writeText("{{" + t + "}}").then(() => {
        this.$emitter.emit("success", { message: t + " copied to clipboard." });
        this.showSideBar = false;
      });
    },
    handleDeleteClick() {
      this.$emit("onDelete", this.myNotification);
    },
    dimPage() {
      this.$emit("onDimPage", {});
    },
    upsertNotification() {
      this.hasTemplateError = false;
      if (this.myNotification.day == null && !this.myNotification.onGoingDay) {
        this.$emitter.emit(
          "error",
          "Please choose the number of days for the notification after the decline"
        );
        return;
      }

      if (this.myNotification.message.indexOf("linkForPayment}}") <= 0) {
        this.hasTemplateError = true;
        return;
      }

      this.$emit("onUpserted", this.myNotification);
    },
  },
};
</script>

<style>
#sidebar-pddf.b-sidebar {
  width: 400px;
}
</style>
